(() => {
  if (window.__CANUTS_COLLECTION_BUY_LOADED__) return;
  window.__CANUTS_COLLECTION_BUY_LOADED__ = true;

  document.addEventListener('click', onCollectionBuyClick);
  document.addEventListener('change', onQtyInputChange);

  async function onCollectionBuyClick(event) {
    const variantBtn = event.target.closest('.cn-variant');
    if (variantBtn) {
      handleVariantSelection(variantBtn);
      return;
    }

    const qtyBtn = event.target.closest('.cn-qty-btn');
    if (qtyBtn) {
      handleQtyButton(qtyBtn);
      return;
    }

    const addBtn = event.target.closest('.cn-add-cart');
    if (!addBtn) return;

    event.preventDefault();

    if (addBtn.dataset.loading === 'true') return;

    const wrap = addBtn.closest('.cn-card-buy');
    if (!wrap) return;

    const card = addBtn.closest('.product-card');
    const qtyInput = wrap.querySelector('.cn-qty-input');
    const quantity = Math.max(1, parseInt(qtyInput?.value || '1', 10) || 1);
    const variantId = parseInt(addBtn.dataset.variantId || '0', 10);

    if (!variantId) return;

    const textNode = addBtn.querySelector('.cn-add-cart__text');
    const iconNode = addBtn.querySelector('.cn-add-cart__icon');
    const originalText = textNode ? textNode.textContent : 'Adicionar ao carrinho';
    const originalIcon = iconNode ? iconNode.innerHTML : '';

    addBtn.dataset.loading = 'true';
    addBtn.disabled = true;
    addBtn.classList.add('is-loading');
    addBtn.setAttribute('aria-busy', 'true');

    if (card) {
      card.classList.add('adding');
    }

    if (textNode) {
      textNode.textContent = 'Adicionando';
    }

    try {
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: quantity
            }
          ]
        })
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result?.description || 'Erro ao adicionar ao carrinho');
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true
        })
      );

      openCartDrawer();

      addBtn.classList.remove('is-loading');
      addBtn.classList.add('is-added');

      if (textNode) {
        textNode.textContent = 'Adicionado';
      }

      if (iconNode && window.innerWidth < 700) {
        iconNode.innerHTML = '✓';
      }
    } catch (error) {
      console.error('[CA.NUTS collection buy]', error);

      addBtn.classList.remove('is-loading');

      if (textNode) {
        textNode.textContent = 'Erro';
      }
    } finally {
      window.setTimeout(() => {
        addBtn.dataset.loading = 'false';
        addBtn.disabled = false;
        addBtn.classList.remove('is-loading');
        addBtn.classList.remove('is-added');
        addBtn.removeAttribute('aria-busy');

        if (card) {
          card.classList.remove('adding');
        }

        if (textNode) {
          textNode.textContent = originalText;
        }

        if (iconNode && window.innerWidth < 700) {
          iconNode.innerHTML = originalIcon;
        }
      }, 850);
    }
  }

  function handleVariantSelection(variantBtn) {
    const wrap = variantBtn.closest('.cn-card-buy');
    if (!wrap) return;

    wrap.querySelectorAll('.cn-variant.is-active').forEach((btn) => {
      btn.classList.remove('is-active');
    });

    variantBtn.classList.add('is-active');

    const addBtn = wrap.querySelector('.cn-add-cart');
    if (addBtn) {
      addBtn.dataset.variantId = variantBtn.dataset.variantId;
    }

    updateCardPrice(wrap, variantBtn.dataset.price, variantBtn.dataset.comparePrice);
  }

  function handleQtyButton(qtyBtn) {
    const qtyWrap = qtyBtn.closest('.cn-qty');
    if (!qtyWrap) return;

    const input = qtyWrap.querySelector('.cn-qty-input');
    let value = parseInt(input.value || '1', 10);

    if (Number.isNaN(value) || value < 1) {
      value = 1;
    }

    if (qtyBtn.dataset.action === 'plus') {
      input.value = value + 1;
      return;
    }

    if (qtyBtn.dataset.action === 'minus') {
      input.value = Math.max(1, value - 1);
    }
  }

  function onQtyInputChange(event) {
    const qtyInput = event.target.closest('.cn-qty-input');
    if (!qtyInput) return;

    let value = parseInt(qtyInput.value || '1', 10);

    if (Number.isNaN(value) || value < 1) {
      value = 1;
    }

    qtyInput.value = value;
  }

  function updateCardPrice(cardBuyWrap, price, comparePrice) {
    const productCard = cardBuyWrap.closest('.product-card');
    if (!productCard) return;

    const priceWrap = productCard.querySelector('.cn-price-wrap');
    if (!priceWrap) return;

    const finalPrice = price || '';
    const finalCompare = comparePrice || '';

    if (finalCompare.trim() !== '') {
      priceWrap.innerHTML = `
        <span class="cn-price-data" data-price='${finalPrice}' data-compare-price='${finalCompare}'></span>
        <price-list class="price-list">
          <sale-price class="sale-price">${finalPrice}</sale-price>
          <compare-at-price class="compare-at-price">De ${finalCompare}</compare-at-price>
        </price-list>
      `;
    } else {
      priceWrap.innerHTML = `
        <span class="cn-price-data" data-price='${finalPrice}' data-compare-price=''></span>
        <price-list class="price-list">
          <sale-price class="sale-price">${finalPrice}</sale-price>
        </price-list>
      `;
    }
  }

  function openCartDrawer() {
    const drawer =
      document.querySelector('cart-drawer') ||
      document.querySelector('#cart-drawer') ||
      document.querySelector('[id*="cart-drawer"]') ||
      document.querySelector('.drawer[id*="cart"]');

    if (drawer) {
      if (typeof drawer.show === 'function') {
        drawer.show();
        return;
      }

      if (typeof drawer.open === 'function') {
        drawer.open();
        return;
      }

      drawer.setAttribute('open', '');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open', 'active');
      return;
    }

    const toggle =
      document.querySelector('[aria-controls="cart-drawer"]') ||
      document.querySelector('a[href$="/cart"]') ||
      document.querySelector('a[href*="/cart"]');

    if (toggle) {
      toggle.click();
    }
  }
})();
